import session from '../util/session'

type ElementWithUpdateVideoSeen = HTMLElement & { updateVideoSeen: () => void }

up.compiler(
  '[data-mark-video-as-seen]',
  (element: HTMLElement, { videoId }: { videoId: number }) => {
    function updateVideoSeen() {
      const hasSeen = session.seenVideoIds.includes(videoId)
      element.classList.toggle('-seen', hasSeen)
    }

    updateVideoSeen()
    ;(element as ElementWithUpdateVideoSeen).updateVideoSeen = updateVideoSeen
  },
)

up.on('app.session.videoSeen', () => {
  for (const element of document.querySelectorAll<ElementWithUpdateVideoSeen>(
    '[data-mark-video-as-seen]',
  )) {
    element.updateVideoSeen?.()
  }
})
